/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: ESM Woocommerce to Hubspot Integration
  Author: Wibert Muza
  Agency URL: https://esminbound.com
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME(state, val)           { state.theme             = val   },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY           = val   }, 


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and sessionStorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data sessionStorage
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in sessionStorage
        userInfo[property] = payload[property]
      }

    }

    if (payload !== null && "cards" in payload && "orderHistory" in payload.cards && payload.cards.orderHistory.length > 0) {
      state.AppActiveUser.dashboardOrders = payload.cards.orderHistory.filter((i, index) => (index < 7))
      state.AppActiveUser.allOrders = state.AppActiveUser.cards.orderHistory.length
      state.AppActiveUser.allCustomers = state.AppActiveUser.cards.customerHistory.length
      state.AppActiveUser.allErrors = state.AppActiveUser.cards.customerErrors.length + state.AppActiveUser.cards.orderErrors.length + state.AppActiveUser.cards.productErrors.length

      //revenue generated states
      let arr4 = [], revenueTotal = 0;  
      payload.cards.orderHistory.map((order) => { 
          revenueTotal = Number(order.price) + revenueTotal;
          arr4.push( Number(order.price) )          
      }); 
      state.AppActiveUser.revenueSeries = [0, parseInt(revenueTotal) ? parseInt(revenueTotal) : 0];
      state.AppActiveUser.revenueGenerated = parseInt( arr4.reduce((a, b) => a + b, 0) );

      //Calculate orders completed and in progress as well as the percentage 
      state.AppActiveUser.goalOverview.series = parseInt( ( (state.AppActiveUser.cards.orderHistory.reduce(function (n, order) { return n + (order.status == "completed") }, 0)) / state.AppActiveUser.cards.orderHistory.length ) * 100 )

      //Re-order the order history by order date
      let finalObj = {}
      payload.cards.orderHistory.map((order) => {
        let dt = new Date( Number(order.date) );
        let dd = dt.getDate();
        let mm = dt.getMonth() + 1; //January is 0!
        let yyyy = dt.getFullYear();
        if (dd < 10) { dd = '0' + dd; } 
        if (mm < 10) { mm = '0' + mm; } 
        let tdate = dd + '-' + mm + '-' + yyyy
        if (finalObj[tdate]) {
          finalObj[tdate] = finalObj[tdate] + Number(order.price);
        } else {
          finalObj[tdate] = Number(order.price);
        }
      })
      state.AppActiveUser.groupedOrders = finalObj;

    }

    // Store data in sessionStorage
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))    
  },

  //Update the WooCommerce to Hubspot integration Status
  UPDATE_ENABLED (state, message) {
    state.AppActiveUser.cards.property_mappings.enabled = message
  },

  //Update the Hubspot Connection Status
  UPDATE_HUBSPOT (state, message) {
    state.AppActiveUser.cards.active = message
  },

  //Update the WooCommerce Connection Status
  UPDATE_WOOCOMMERCE (state, message) {
    state.AppActiveUser.cards.wooActive = message
  },

  //Update the WooCommerce Store Url
  UPDATE_STOREURL (state, message) {
    state.AppActiveUser.cards.wooStoreUrl = message
  },

  //Update property mappings to default
  UPDATE_PROPERTY_MAPPINGS (state, message) {
    state.AppActiveUser.cards.property_mappings = message
  },

  //Update order history to default 
  UPDATE_ORDER_HISTORY (state, message) {
    state.AppActiveUser.cards.orderHistory = message
  },

  //Update product history to default 
  UPDATE_PRODUCT_HISTORY (state, message) {
    state.AppActiveUser.cards.productHistory = message
  },

  //Update customer history to default 
  UPDATE_CUSTOMER_HISTORY (state, message) {
    state.AppActiveUser.cards.customerHistory = message
  },

  //Update order errors to default 
  UPDATE_ORDER_ERRORS (state, message) {
    state.AppActiveUser.cards.orderErrors = message
  },

  //Update product errors to default 
  UPDATE_PRODUCT_ERRORS (state, message) {
    state.AppActiveUser.cards.productErrors = message
  },

  //Update customer errors to default 
  UPDATE_CUSTOMER_ERRORS (state, message) {
    state.AppActiveUser.cards.customerErrors = message
  },

  //Update the dashboard Orders 
  UPDATE_DASHBOARD_ORDERS (state, message) {
    state.AppActiveUser.dashboardOrders = message
  },

  //Logout User by setting state to default
  LOGOUT_USER (state) {
    state.AppActiveUser = state.AppActiveUser.defaultState
    sessionStorage.removeItem('userInfo')
    sessionStorage.removeItem("vuex"); 
    location.reload();
  },

}

export default mutations

